import React from 'react';
import { Link } from 'react-router-dom';
import LandingNav from '../components/LandingNav';
import Footer from '../components/Footer';
import './DataDeletion.css';

const DataDeletion = () => {
  return (
    <div className="data-deletion-page">
      <LandingNav />
      <div className="data-deletion-content">
        <div className="data-deletion-container">
          <h1 className="data-deletion-title">DATA DELETION INSTRUCTIONS</h1>
          <p className="data-deletion-subtitle">TRCKLE</p>
          
          <p className="data-deletion-intro">
            If you want to delete your Trckle account or remove connected social media data, follow one of the options below.
          </p>

          <div className="deletion-section">
            <h2>1. Delete Your Account</h2>
            <p>
              Email <a href="mailto:trcklesocial@gmail.com" className="email-link">trcklesocial@gmail.com</a> with the subject line:
            </p>
            <div className="subject-box">
              "Delete My Trckle Account"
            </div>
            <p className="deletion-info">We will permanently delete:</p>
            <ul className="deletion-list">
              <li>Your account</li>
              <li>All connected social tokens</li>
              <li>All scheduled content</li>
              <li>All analytics associated with your profile</li>
            </ul>
          </div>

          <div className="deletion-section">
            <h2>2. Remove Social Media Permissions</h2>
            <p>Users may disconnect accounts directly inside Trckle or through each platform's settings:</p>
            <ul className="platform-list">
              <li>
                <strong>Facebook/Instagram:</strong>{' '}
                <a href="https://www.facebook.com/settings?tab=business_tools" target="_blank" rel="noopener noreferrer" className="platform-link">
                  https://www.facebook.com/settings?tab=business_tools
                </a>
              </li>
              <li>
                <strong>TikTok:</strong> Settings → Apps & Websites
              </li>
              <li>
                <strong>Twitter/X:</strong> Settings → Connected Apps
              </li>
              <li>
                <strong>YouTube:</strong> Google Account → Security → Third-party apps
              </li>
            </ul>
            <p className="note">Once disconnected, Trckle loses access immediately.</p>
          </div>

          <div className="back-link-container">
            <Link to="/" className="back-link">← Back to Home</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DataDeletion;
